module.exports = __webpack_public_path__ + "static/media/featured-3-bed.1ce2fc37.png";